import PopupCheats, { Item } from '../cheats/PopupCheats';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { CheatData } from '../cheats/cheats.sequences';
import { closeAllPopups } from 'src/lib/popups/popupOpenClose';
import { getApplication, getFooter } from 'src/lib/utils';
import StateObserver from 'src/StateObserver';

function getCurrentScene() {
  const { screenManager } = getApplication();
  if (!screenManager.enteredScreen) return undefined;
  const screen = screenManager.screens[screenManager.enteredScreen];
  return screen?.currentScene;
}

const MATCH2_RESCUE_LEVEL = 'match2 Rescue Level';

const list = () => {
  const cheats: Record<string, CheatData[]> = {};

  cheats[MATCH2_RESCUE_LEVEL] = [
    {
      text: 'Activate Crocodile',
      color: 'secondary',
      level: true,
      cheat: async () => {
        closeAllPopups();
        await StateObserver.invoke.cheat_rescueLevelActivateCrocodile();
        void getFooter()?.minigameButton.playLevelUp();
      },
    },
    {
      text: 'Activate Frozen',
      color: 'secondary',
      level: true,
      cheat: async () => {
        closeAllPopups();
        await StateObserver.invoke.cheat_rescueLevelActivateFrozen();
        void getFooter()?.minigameButton.playLevelUp();
      },
    },
    {
      text: 'RESET',
      color: 'cancel',
      level: true,
      cheat: async () => {
        closeAllPopups();
        await StateObserver.invoke.cheat_rescueLevelReset();
        void getFooter()?.minigameButton.playLevelUp();
      },
    },
    {
      text: 'Auto Win',
      color: 'secondary',
      gameplay: true,
      cheat: async () => {
        closeAllPopups();
        const scene = getCurrentScene();
        scene?.getView().emit('RescueLevelAutoWin');
      },
    },
    {
      text: 'To 12 secs',
      color: 'secondary',
      gameplay: true,
      cheat: async () => {
        closeAllPopups();
        const scene = getCurrentScene();
        scene?.getView().emit('RescueLevel12Secs');
      },
    },
    {
      text: 'To 3 secs',
      color: 'secondary',
      gameplay: true,
      cheat: async () => {
        closeAllPopups();
        const scene = getCurrentScene();
        scene?.getView().emit('RescueLevel3Secs');
      },
    },
  ];

  return cheats;
};

const ui = (args: {
  key: string;
  popup: PopupCheats;
  item: Item;
  title: LangBitmapFontTextView;
  setting: CheatData[];
  parent: Item | null;
}) => {
  if (args.key !== MATCH2_RESCUE_LEVEL) return;
  args.title.updateOpts({
    width: args.item.style.width - 40,
    height: 20,
    y: 8,
    align: 'center',
  });
  args.popup.createVerticalButtons(args.item, args.setting);
};

export const rescueLevelCheats = {
  list,
  ui,
};
